import React, { useState } from "react";
import styled from "styled-components";
import { ReactComponent as Arrow } from "./../../atoms/icons/arrow.svg";
import enhanceWithClickOutside from "react-click-outside";

const Wrap = styled.div`
    width: calc(50% - 8px);

    @media (min-width: 990px) {
        position: relative;
    }
`;

const Button = styled.button`
    position: relative;
    width: 100%;
    height: 32px;
    border-radius: 3px;
    border: solid 1px #e6e6e6;
    padding: 4px 40px 4px 12px;
    background: transparent;
    color: #5f645f;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    cursor: pointer;
    user-select: none;
    outline: none;
    box-shadow: none;

    &:focus,
    &:hover,
    &:active {
        outline: none;
        box-shadow: none;
    }

    span {
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        overflow: hidden;
    }

    svg {
        position: absolute;
        top: 3px;
        right: 7px;
        background: #fff;
    }

    &.active svg {
        transform: rotate(180deg);
    }

    b.desktop-show {
        display: none;
    }

    @media (min-width: 990px) {
        font-size: 14px;
        b {
            display: none;
        }
        b.desktop-show {
            display: inline;
        }
    }
`;

const Inner = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    padding: 0 24px 0 24px;
    z-index: 3;
    background: #fff;
    box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.08);

    @media (min-width: 990px) {
    }
`;

const Ul = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

const Li = styled.li`
    padding: 0;
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
`;

const Input = styled.input`
    display: none;

    &:checked + label {
        background-color: #f4f4f4;
    }
`;

const Label = styled.label`
    display: block !important;
    margin: 0 -24px;
    padding: 11px 24px;
    cursor: pointer;

    &:hover {
        background-color: #f4f4f4;
    }
`;

function Diet(props) {
    const { diets, selectedDiet, dietChange } = props;
    const [show, setShow] = useState(false);

    const onClick = () => {
        setShow(!show);
    };
    const handleOnChange = (e) => {
        dietChange(e);
        setShow(false);
    };

    return (
        <Wrap className="inner-settings__item">
            <Button
                onClick={onClick}
                className={show === true ? "active" : ""}
            >
                <span>
                    <b>Filter:</b>&nbsp;
                    <b className="desktop-show">Filter by:</b>&nbsp;
                    {selectedDiet.length > 0 ? selectedDiet : "All diets"}
                </span>
                <Arrow />
            </Button>
            {show ? (
                <Inner>
                    <Ul>
                        {diets.map((diet) => {
                            const name = diet.name
                                .toLowerCase()
                                .replace(/\s/g, "-");

                            const activeClass =
                                diet.name.toLowerCase() ===
                                    selectedDiet.toLowerCase()
                                    ? true
                                    : false;

                            return (
                                <Li key={diet.id}>
                                    <Input
                                        type="checkbox"
                                        id={"label-" + name}
                                        name={name}
                                        value={diet.name}
                                        onChange={handleOnChange}
                                        checked={activeClass}
                                    />
                                    <Label htmlFor={"label-" + name}>
                                        {diet.name}
                                    </Label>
                                </Li>
                            );
                        })}
                    </Ul>
                </Inner>
            ) : null}
        </Wrap>
    );
}

export default enhanceWithClickOutside(Diet);
